// src/components/layout/Header.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { getTranslations } from '../../languages';
import { useTheme } from '../../contexts/ThemeContext';
import LanguageSelector from '../common/LanguageSelector';

function Header() {
  // Get current language and translations
  const { language } = useLanguage();
  const translations = getTranslations(language);
  const { isDarkMode, toggleTheme } = useTheme();
  
  // State für das mobile Menü
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  
  // Handle scroll event
  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 50;
      setScrolled(isScrolled);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Toggle-Funktion für das Menü
  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    
    // Toggle der body-Klasse zum Verhindern des Scrollens
    if (!mobileMenuOpen) {
      document.body.classList.add('menu-open');
    } else {
      document.body.classList.remove('menu-open');
    }
  };

  // Menü schließen, wenn ein Link angeklickt wird
  const closeMenu = () => {
    setMobileMenuOpen(false);
    document.body.classList.remove('menu-open');
  };

  return (
    <header className={`site-header ${scrolled ? 'scrolled' : ''}`}>
      <Link to={`/${language}`} className="logo">
        <img 
          src={isDarkMode 
            ? "/images/Logo/LucentWebDesign_HorizontalLogo_WhiteText.svg"
            : "/images/Logo/LucentWebDesign_HorizontalLogo_DarkText.svg"
          }
          alt="Lucent Web Design"
          className="logo-img"
        />
      </Link>
      
      {/* Burger-Menü Button (nur auf kleineren Bildschirmen sichtbar) */}
      <button 
        className={`mobile-menu-toggle ${mobileMenuOpen ? 'active' : ''}`} 
        onClick={toggleMobileMenu}
        aria-label="Toggle Menu"
      >
        <span className="burger-line"></span>
        <span className="burger-line"></span>
        <span className="burger-line"></span>
      </button>
      
      {/* Navigation mit der responsiven Klasse */}
      <nav className={`main-nav ${mobileMenuOpen ? 'menu-open' : ''}`}>
        <ul>
          <li><Link to={`/${language}`} onClick={closeMenu}>{translations.nav.home}</Link></li>
          <li><Link to={`/${language}/services`} onClick={closeMenu}>{translations.nav.services}</Link></li>
          <li><Link to={`/${language}/portfolio`} onClick={closeMenu}>{translations.nav.portfolio}</Link></li>
          <li><Link to={`/${language}/about`} onClick={closeMenu}>{translations.nav.about}</Link></li>
          <li><Link to={`/${language}/team`} onClick={closeMenu}>{translations.nav.team}</Link></li>
          <li><Link to={`/${language}/contact`} onClick={closeMenu}>{translations.nav.contact}</Link></li>
        </ul>
        
        {/* TopBar items for mobile menu */}
        <div className="mobile-menu-extras">
          <button 
            onClick={toggleTheme} 
            className="mobile-theme-toggle"
            aria-label="Toggle theme"
          >
            {isDarkMode ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="5"></circle>
                <line x1="12" y1="1" x2="12" y2="3"></line>
                <line x1="12" y1="21" x2="12" y2="23"></line>
                <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line>
                <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line>
                <line x1="1" y1="12" x2="3" y2="12"></line>
                <line x1="21" y1="12" x2="23" y2="12"></line>
                <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line>
                <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>
              </svg>
            )}
          </button>
          <div className="mobile-language-toggle">
            <button onClick={() => {
              const currentPath = window.location.pathname;
              const newLang = language === 'en' ? 'de' : 'en';
              const pathParts = currentPath.split('/').filter(Boolean);
              pathParts[0] = newLang;
              window.location.pathname = '/' + pathParts.join('/');
            }} className="lang-button">
              {language === 'en' ? 'DE' : 'EN'}
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;